export const faqItems = [
  {
    question: '欲望之岛是什么？',
    answer: '欲望之岛是一个沉浸式的自我探索平台，帮助你发现内心深处最真实的渴望。我们通过文章、活动和社区互动，为你提供一个安全、非评判的空间，让你能够直面自己的欲望，理解它们，并将它们转化为成长的动力。',
  },
  {
    question: '加入欲望之岛需要付费吗？',
    answer: '欲望之岛的基础内容对所有用户免费开放。我们相信每个人都应该有探索自我的权利。同时，我们也提供一些深度工作坊和一对一辅导等增值服务，这些服务会收取一定费用以支持平台的持续运营。',
  },
  {
    question: '我的隐私如何得到保护？',
    answer: '隐私是我们最重视的价值之一。欲望之岛采用行业领先的加密技术保护你的数据，所有个人信息严格保密，绝不与第三方分享。你可以放心地在这里探索自己的内心世界。',
  },
  {
    question: '欲望之岛适合什么样的人？',
    answer: '欲望之岛适合所有对自我探索感兴趣的人——无论你是在寻找人生方向、希望改善亲密关系、想要突破自我限制，还是单纯地对人类的欲望本质感到好奇。只要你对内心世界有着探索的热情，这里就是你的归属。',
  },
  {
    question: '我可以参与欲望之岛的线下活动吗？',
    answer: '是的！欲望之岛定期在北京、上海、深圳、成都等城市举办线下体验活动和主题工作坊。关注我们的公众号或订阅邮件通知，获取最新的活动信息。',
  },
  {
    question: '如何开始我的探索之旅？',
    answer: '很简单！你可以从浏览我们的精选文章开始，找到最能引起你共鸣的主题。然后可以参加我们的线上讨论，或者报名参加入门工作坊。最重要的是——保持一颗开放和好奇的心。',
  },
  {
    question: '你们的文章是基于什么理论依据？',
    answer: '欲望之岛的内容融合了现代心理学（包括荣格分析心理学、人本主义心理学）、神经科学、东方哲学传统以及大量实证研究。我们与多位心理学家、哲学家和身心健康专家合作，确保内容的科学性和深度。',
  },
];